import { render, staticRenderFns } from "./KeywordsPage.vue?vue&type=template&id=16e124c6&scoped=true&"
import script from "./KeywordsPage.vue?vue&type=script&lang=js&"
export * from "./KeywordsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16e124c6",
  null
  
)

export default component.exports